window.elmSetWidget = false;
window.isWidgetElement = false;

(function ($) {
    //editor ready
    var bt$ = function (o) {
        var fb = $('#frameBody').get(0).contentWindow;
        return fb.$('#selected_body').find(o);
    };

    var fb$ = function () {
        return (fb = $('#frameBody').get(0).contentWindow.$);
    };
    RVwys.plugin['Widget'] = true;

    RVwys.widget.blog = {};
    RVwys.widget.procF = {};
    RVwys.widget.countError = 0;
    RVwys.widget.errorTimeDec = 50;
    RVwys.widget.msgError = false;
    $(document).bind('editorReady', function () {
        if (parent.$('#isType').val() != 'Post') {
            var disable = [
                'li[data-widgetname="blog_next_previous"]',
                'li[data-widgetname="blog_navi"]',
                'li[data-widgetname="blog_post_info"]',
                'li[data-widgetname="blog_post_in_cat"]',
            ];
            var widgetAll = disable.join(',');
            $(widgetAll).hide();
        }
    });

    RVwys.widget.overlay = function (expression) {
        if (!expression) expression = 'show';
        switch (expression) {
            case 'show':
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': '#ccc',
                    opacity: '0.5',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });

                var oLoad = $(
                    '<img class="loading" src="' +
                        parent.wex.url.WYS_IMG_URL +
                        'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />'
                );
                parent
                    .$('body')
                    .prepend(overlaypanel.clone().find('img').remove().end());
                $('body').prepend(overlaypanel.append(oLoad));
                break;
            case 'hide':
                $('.overlaypanel').remove();
                parent.$('.overlaypanel').remove();
                break;
            default:
            // code block
        }
    };
    RVwys.widget.widgetNotAciveLink = function (oThis) {
        if ($(oThis).attr('nowidget') != undefined) return false;
        if ($(oThis).parent().parent().hasClass('pagination')) return false;

        $('.linkToolEditable').show();
        $('.linkToolEditable')
            .find('.linkToEdit')
            .hide()
            .end()
            .find('.linkToRemove')
            .hide()
            .end()
            .find('.buttonToClipboard')
            .hide()
            .end()
            .find('.buttonToEdit')
            .hide()
            .end();

        var h = $(oThis).attr('href') || '';

        h = h.replace(parent.wex.url.baseUrl, parent.wex.url.WYS_SHOW_URL);
        var oLinkk = $(
            '<a href="' +
                h +
                '"> <i class="uk-icon-external-link"></i>  ' +
                h +
                '</a>'
        );
        if (!h.match(/^\#/)) {
            oLinkk.attr('target', '_blank');
        }

        $('.linkTo').html(oLinkk);
        $('.linkToolEditable').css({
            left: $(oThis).offset().left,
            top: $(oThis).offset().top,
        });
        return false;
    };
    RVwys.widget.insCommon = function (oThis, isWhere = null) {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var data = oThis.data();
        data.id = $.md5(String($.now()));
        data.act = oThis.attr('data-action')
            ? oThis.attr('data-action')
            : '/admin/wysiwyg/widget/widgetsection';
        data.widgetname = oThis.attr('data-widgetname');

        data.panel = oThis.attr('data-panel')
            ? oThis.attr('data-panel')
            : '.' + data.widgetname;
        data.widget = oThis.attr('data-widget')
            ? oThis.attr('data-widget')
            : data.widget;
        data.appname = data.widget;

        data.insertby = isWhere ? isWhere : '';

        data.slug_name = parent.slugname;
        data._token = $('meta[name="csrf-token"]').attr('content');
        var selElm = fb
            .$(
                `.blockWidget[widgetname="${data.widgetname}"][widget="${data.appname}"]`
            )
            .find('img[class^="img"]');
        //.find('.img' + data.widgetname);
        console.log(
            fb
                .$(
                    `.blockWidget[widgetname="${data.widgetname}"][widget="${data.appname}"]`
                )
                .get(0)
        );
        console.log(selElm.get(0));
        var ui = $('<div/>').append(selElm.clone().hide());
        var uiImg = ui.find('img');
        console.log('widget data');
        console.log(data);
        console.log(ui.get(0));
        /*
        if ($.isFunction(parent.RVwys.widget[data.widget].setting)) {
            var settings = parent.RVwys.widget[data.widget].setting(ui);
        } else {
            var settings = RVwys.widget[data.widget].setting(ui);
        }

        console.log(settings);
        var settings = JSON.parse(
            JSON.stringify(settings).replace(/\"([^\"]*?)\"\:/gim, function(
                m,
                i
            ) {
                return '"setting_' + i + '":';
            })
        );
                */

        //uiImg.attr(settings);
        uiImg.attr({
            widget: data.widget,
            id: data.id,
            insertby: data.insertby,
        });
        data.image = uiImg.get(0).outerHTML;

        return data;
    };
    RVwys.widget.insertElement = function (oThis) {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var oThis = oThis.closest('li').find('[data-panel]');
        var realData = RVwys.widget.insCommon(oThis, 'element');

        var placeHolder = fb.$(realData['image']);
        realData.id = 'img' + realData.id;
        delete realData['image'];
        placeHolder.addClass('insertwidget').attr(realData);
        fb.RVwys.removePreviewWidget();
        $.when(
            RVwys.insertHTML(placeHolder.show()),
            RVwys.hideTopBarTool($(this)),
            fb.RVwys.widget.elementClick(placeHolder)
        ).then(function (x) {
            fb.$('html, body').animate(
                {
                    scrollTop: placeHolder.offset().top,
                },
                1000,
                function () {
                    placeHolder.get(0).focus();
                }
            );
        });
    };

    RVwys.widget.insertBlock = function (oThis) {
        var fb = $('#frameBody').get(0).contentWindow;
        var oThis = oThis.closest('li').find('[data-panel]');
        var realData = RVwys.widget.insCommon(oThis, 'block');
        //alert(realData.insertBy);

        RVwys.widget.insertSection(
            oThis,
            {
                data: realData,
                success: function (response) {
                    RVwys.widget.overlay('hide');
                    var oRes = $(
                        '<div class="RVWYSIWYGAREAWIDGET">' +
                            response.replace('href', 'hrefs') +
                            '</div>'
                    );
                    var fb = $('#frameBody').get(0).contentWindow;

                    var editorCur =
                        fb.RVwys.currentiFrame != ''
                            ? fb.$(fb.RVwys.currentiFrame)
                            : bt$('.RVWYSIWYGAREA').eq(0);

                    var layoutBlock = editorCur.parent().clone();
                    console.log('insert block');
                    console.log(layoutBlock.get(0));
                    //containerWidget

                    $.when(
                        layoutBlock.find('.RVWYSIWYGAREA').remove(),
                        layoutBlock.html(oRes),
                        oRes
                            .find('.containerWidget')
                            .attr({
                                onmouseup:
                                    'RVwys.widget.activeBlock($(this).parent())',
                                panel: realData.panel,
                                widget: realData.widget,
                                widgetname: realData.widgetname,
                            })
                            .after(realData.image),
                        editorCur.parent().after(
                            layoutBlock
                                .find('a')
                                .click(function () {
                                    return fb.RVwys.widget.widgetNotAciveLink(
                                        this
                                    );
                                })
                                .end()
                        )
                    ).then(function () {
                        fb.RVwys.widget.activeBlock(
                            oRes.find('.containerWidget').parent()
                        );
                        fb.$('html, body').animate(
                            {
                                scrollTop: editorCur.offset().top,
                            },
                            1000,
                            function () {
                                editorCur.get(0).focus();
                            }
                        );
                    });
                },
                error: function (err) {
                    RVwys.widget.overlay('hide');
                    parent.console.pop.error({
                        text: err.message,
                        delay: 1000,
                    });
                },
            },
            'block'
        );
    };
    RVwys.widget.insertSection = function (
        oThis,
        callback = null,
        iswhere = null
    ) {
        var oThis = oThis.closest('li').find('[data-panel]');
        iswhere = iswhere ? iswhere : 'section';
        var realData = RVwys.widget.insCommon(oThis, iswhere);
        //var data = jQuery.param( oThis.data());
        console.log('SEC');
        console.log(realData);
        var fb = $('#frameBody').get(0).contentWindow;
        fb.RVwys.removePreviewWidget();
        var send = {
            type: 'POST',
            url: wex.url.baseUrl + realData.act,
            data: realData,

            success: function (response) {
                console.log(response);
                RVwys.widget.overlay('hide');

                var oRes = $(
                    '<div class="uk-width-medium-1-1">' +
                        response.replace('href', 'hrefs') +
                        '</div>'
                );
                var fb = $('#frameBody').get(0).contentWindow;

                var oMG = bt$('.mgActive').get(0)
                    ? bt$('.mgActive').closest('.mg')
                    : bt$('.sidebar-center').find('.mg').eq(0);
                var newObj = oMG.clone();
                fb.$('.mgActive').removeClass('mgActive');
                var bms = fb.$('#blockMainSetting');

                $.when(
                    newObj.removeClass('donotdelete'),
                    newObj
                        .removeClass('mgwidget')
                        .addClass('mgwidget')
                        .find('.navMenuAll')
                        .remove()
                        .end()
                        .find('.rvsb_design_block')
                        .find('.rv-b-grid,.uk-grid')
                        .eq(0)
                        .html(oRes),
                    newObj.find('.rvsb_design_block').prepend(bms.html()),
                    oRes.find('.containerWidget').after(realData.image),
                    newObj.attr({
                        onclick: 'RVwys.widget.ovewEvent(this)',
                        panel: realData.panel,
                        widget: realData.widget,
                        widgetname: realData.widgetname,
                    }),
                    oMG.after(
                        newObj
                            .find('a')
                            .click(function () {
                                return fb.RVwys.widget.widgetNotAciveLink(this);
                            })
                            .end()
                    )
                ).then(function (x) {
                    fb.RVwys.widget.ovewEvent(newObj);
                    fb.$('html, body').animate(
                        {
                            scrollTop: newObj.offset().top,
                        },
                        1000,
                        function () {
                            newObj.get(0).focus();
                        }
                    );
                    setTimeout(function () {
                        newObj.click();
                    }, 500);
                });
            },
            error: function (err) {
                RVwys.widget.overlay('hide');
                parent.console.pop.error({
                    text: err.message,
                    delay: 1000,
                });
            },
        };
        if (callback) {
            send = $.extend(true, send, callback);
        }
        RVwys.widget.overlay('show');
        $.ajax(send);
    };

    //widget ready
    $(document).bind('designReady', function (e) {
        var oRolsBlock = $('.rightbar');

        oRolsBlock.find('icon-widget').each(function () {
            var oWidget = $(this)
                .find('.blockWidget')
                .attr('data', $(this).next('design').html());
            $(this).next('design').remove();
            oWidget.unwrap();
        });

        $("[insertby='block']")
            .prev('.containerWidget')
            .each(function () {
                var oNext = $(this).next();
                var opt = {
                    onmouseup: 'RVwys.widget.activeBlock($(this).parent())',
                    panel: '.' + oNext.attr('widgetname'),
                    widget: oNext.attr('widget'),
                    widgetname: oNext.attr('widgetname'),
                };
                $(this).attr(opt);
            });
        $('.RVWYSIWYGAREA').find('.containerWidget').remove(); // case insert widget element
        //display none if page not blog
        if (parent.$('#isType').val() != 'Post') {
            $('.blockWidget').each(function () {
                if (
                    $(this).attr('widgetname') == 'blog-next-previous' ||
                    $(this).attr('widgetname') == 'blog-navi' ||
                    $(this).attr('widgetname') == 'blog-post-info' ||
                    $(this).attr('widgetname') == 'blog-post-in-cat'
                ) {
                    $(this).hide();
                }
            });
        }
        RVwys.widget.ovewEvent = function (oths) {
            parent.window.isWidgetElement = window.isWidgetElement = false;
            oths = $(oths);
            parent.RVwys.getRowBG = oths.find('.rvsb_design_block');
            console.log('ssssss');
            console.log(parent.RVwys.getRowBG.get(0));
            $('.activeWidget').removeClass('activeWidget');
            oths.find('.containerWidget').addClass('activeWidget');
            parent.window.isWidgetElement = window.isWidgetElement = false;
            if (!$(oths).get(0)) {
                var sectionActive = $('.mgActive');
                oths = sectionActive.closest('.mg');
            }
            RVwys.eventClickblock(oths);
            //RVwys.widget.showPanel(oths);
            console.log(parent.RVwys.widget);
            RVwys.widget.apiWidgetFrame(oths);
        };

        RVwys.widget.activeBlock = function (oths) {
            parent.window.isWidgetElement = window.isWidgetElement = false;
            $('.activeWidget').removeClass('activeWidget');
            oths.addClass('activeWidget');
            $('.blockTools').remove();
            oths.parent().css('position', 'relative');
            RVwys.buildBlockTools(oths.parent());
            parent.RVwys.targetAnimatObj = oths; // use panel animation
            parent.RVwys.getBlockBG = oths; // use panel animation
            oths = $(oths);
            if (!$(oths).get(0)) {
                var sectionActive = $('.mgActive');
                oths = sectionActive.closest('.mg');
            }
            if (oths.hasClass('RVWYSIWYGAREAWIDGET')) {
                oths = oths.find('.containerWidget');
            }
            //RVwys.widget.showPanel(oths,oths.parent());
            RVwys.widget.apiWidgetFrame(oths);
        };

        RVwys.widget.apiWidgetFrame = function (oths, otarget = null) {
            const frameName =
                oths.attr('widget') != undefined
                    ? oths.attr('widget')
                    : 'rvsitebuilder/core';

            const widgetName =
                oths.attr('widgetname') != undefined
                    ? oths.attr('widgetname')
                    : oths.attr('widget-name') != undefined
                    ? oths.attr('widget-name')
                    : oths.find('img[widgetname]').attr('widgetname');

            console.log('widgetName -' + widgetName);
            if (widgetName == undefined) {
                setTimeout(function () {
                    RVwys.widget.apiWidgetFrame(oths, (otarget = null));
                }, 50);
                return false;
            }
            var eWidgetName = widgetName; //== "social" ? "social_widget" : widgetName;
            if (widgetName)
                parent.elmSetWidget = oths.find('.img' + eWidgetName).get(0)
                    ? oths.find('.img' + eWidgetName)
                    : oths.find('.imgBlog');
            console.log('widgetName---');
            console.log(parent.elmSetWidget.get(0));
            console.log(oths.get(0));
            if (oths.attr('data-id')) {
                parent.elmSetWidget = oths
                    .parent()
                    .find('.img' + oths.attr('data-id'));
            }
            if (parent.elmSetWidget.get(0) == undefined) {
                parent.elmSetWidget = oths
                    .parent()
                    .find('.img' + eWidgetName)
                    .get(0)
                    ? oths.parent().find('.img' + eWidgetName)
                    : oths
                          .parent()
                          .find(
                              '.img-' +
                                  oths.attr('widget').replace('/', '-') +
                                  '-' +
                                  oths.attr('widgetname')
                          );
            }

            if (oths.get(0).tagName.toLowerCase() == 'img') {
                parent.elmSetWidget = oths;
            }

            console.log('frameName');
            console.log(oths.get(0));

            const url =
                parent.wex.url.WYS_WIDGET_URL +
                '/' +
                frameName +
                '/' +
                widgetName;

            //frameName = frameName.replace('/','_')
            //if (!parent.$('.panel'+frameName).get(0)) {
            if (
                !parent.$('iframe[data-widgetname=' + widgetName + ']').get(0)
            ) {
                var overlaypanel = parent
                    .$(
                        '<div class="overlaypanel">' +
                            '<img class="loading" src="' +
                            parent.wex.url.WYS_IMG_URL +
                            'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                            '</div>'
                    )
                    .css({
                        width: $('body').width(),
                        height: $('body').height(),
                    });
                //$('.overlaypanel').append(oLoad);
                parent
                    .$('body')
                    .prepend(overlaypanel.clone().find('img').remove().end());
                $('body').prepend(overlaypanel);
                let layoutWidgetFrame = parent.$('.layoutWidgetFrame').html();
                layoutWidgetFrame = layoutWidgetFrame
                    .replace(/\#\#frameName\#\#/gim, frameName)
                    .replace(/\#\#widgetName\#\#/gim, widgetName);
                parent.$('.widdgetFrame').append(layoutWidgetFrame);
                let frameStyle = parent.elmSetWidget.attr('data-frame-style')
                    ? parent.elmSetWidget.attr('data-frame-style')
                    : 'width:240px;height:500px;';

                frameStyle = '{' + frameStyle + '}';
                const oStyle = CSSJSON.toJSONliteral(frameStyle);
                console.log('oStyle');
                console.log(oStyle);
                parent
                    .$('.wys-panel[data-widgetname="' + widgetName + '"]')
                    .css(oStyle.attributes)
                    .find('iframe')
                    .attr('src', url)
                    .end()
                    .find('.widget-showhide')
                    .click(function () {
                        var panel = $(this).closest('.wys-panel,.wys-panels');
                        panel.hide();
                        $('.wys-panel').hide();
                    })
                    .end()
                    .draggable({
                        handle: '.editormode-status',
                        containment: '#fBody',
                        snap: '#fBody',
                        scroll: false,
                        start: function (event, ui) {
                            var overlaypanel = $(
                                '<div class="overlaypanel overlaypanel-d"></div>'
                            ).css({
                                opacity: '0.0',
                                position: 'absolute',
                                left: '0px',
                                top: '0px',
                                width: $('body').width(),
                                height: $('body').height(),
                            });
                            parent.$('body').prepend(overlaypanel);
                        },
                        stop: function (event, ui) {
                            parent.$('.overlaypanel-d').remove();
                        },
                    });
            }
            parent.$('.wys-panel').hide();
            var panelFrame = parent.$(
                '.wys-panel[data-widgetname=' + widgetName + ']'
            );
            panelFrame.show();
            console.log('apiWidgetFrame frameName: ', frameName);
            console.log('apiWidgetFrame widgetName: ', widgetName);

            RVwys.widget.setInputToFrame(frameName, widgetName);
        };

        RVwys.widget.setInputToFrame = function (widget, widgetName) {
            console._method('RVwys.widget.setInputToFrame');
            try {
                var frameWidget = parent
                    .$('iframe[data-widgetname=' + widgetName + ']')
                    .eq(0);

                var wFrame = frameWidget.get(0).contentWindow;
                var widgetname = frameWidget.attr('data-widgetname');

                if (wFrame.document.readyState == 'complete') {
                    var oAttr = RVwys.widget.attr(parent.elmSetWidget);

                    //clear input colorpicker before active
                    if (wFrame.$(wFrame.document).spectrum) {
                        wFrame.$(wFrame.document).click();
                    }
                    const wgTitle = wFrame.$('.txt-title-panel').text();
                    //alert(wgTitle);
                    if (wgTitle) {
                        parent
                            .$("[data-widgetname='" + widgetName + "']")
                            .find('.txt-title-panel')
                            .text(wgTitle);
                    }

                    //parent.RVwys.widget[widget]["set_" + widgetname](oAttr);
                    //wFrame.$(wFrame.document).clickWidget();

                    wFrame.imageSetting = parent.elmSetWidget;
                    wFrame.$(wFrame.document).trigger('widget.click');

                    //wFrame.postMessage("widget.click", "*");
                    console.log('wf cick widget');
                    parent.$('.overlaypanel').remove();
                    $('.overlaypanel').remove();
                } else {
                    setTimeout(function () {
                        RVwys.widget.setInputToFrame(widget, widgetName);
                    }, 50);
                }
            } catch (e) {
                // console.error(e);
                console.focus('RVwys.widget.setInputToFrame: catch');
                console.log(
                    'RVwys.widget.countError: ',
                    RVwys.widget.countError
                );
                RVwys.widget.msgError = e;
                if (RVwys.widget.msgError && RVwys.widget.msgError === e) {
                    RVwys.widget.countError++;
                }
                RVwys.widget.msgError = e;
                if (RVwys.widget.countError < 20) {
                    RVwys.widget.errorTimeDec +=
                        parseInt(RVwys.widget.countError) * 5;
                    setTimeout(function () {
                        console.log(
                            'RVwys.widget.errorTimeDec: ',
                            RVwys.widget.errorTimeDec
                        );
                        RVwys.widget.setInputToFrame(widget, widgetName);
                    }, RVwys.widget.errorTimeDec);
                } else {
                    parent.console.pop.error({
                        text: e,
                        delay: 1000,
                    });
                    RVwys.widget.msgError = false;
                    RVwys.widget.countError = 0;
                    RVwys.widget.errorTimeDec = 50;
                    parent.$('.overlaypanel').remove();
                    $('.overlaypanel').remove();
                }
            }
        };
        RVwys.widget.showPanel = function (oths, otarget = null) {
            parent
                .$('.wys-panel,.widget-blocks,.wys-dynamic,.wys-dynamic')
                .hide();
            //var panel = $(oths).attr('panel');
            var widgetdata = checkWidget($(oths).attr('panel'));
            var panel = $(oths).attr('panel')
                ? $(oths).attr('panel')
                : $(oths).attr('widget-name');

            var widgetname = $(oths).attr('widgetname')
                ? $(oths).attr('widgetname')
                : $(oths).find('[widgetname]').attr('widgetname');

            if (
                (widgetname == 'login-user' || widgetname == 'login-admin') &&
                !$(oths).attr('widget')
            ) {
                $(oths).attr('widget', 'core');
            }
            var widget = $(oths).attr('widget')
                ? $(oths).attr('widget')
                : $(oths).attr('widget-name');

            var prImage = $(oths);
            if (otarget) {
                widgetname = $(otarget).find('[widgetname]').attr('widgetname');
                prImage = otarget;
            }

            parent.elmSetWidget = prImage.find('.img' + widgetname).get(0)
                ? prImage.find('.img' + widgetname)
                : prImage.find('.imgBlog');

            if (prImage.get(0).tagName.toLowerCase() == 'img') {
                parent.elmSetWidget = prImage;
            }
            console.log('parent.elmSetWidget');
            console.log('.img' + widgetname);
            console.log(parent.elmSetWidget.get(0));
            console.log(widget);
            console.log(parent.RVwys.widget[widget]);
            var oAttr = RVwys.widget.attr(parent.elmSetWidget);
            // return;
            const isWidGet = RVwys.widget[widget];
            if (
                typeof isWidGet !== 'undefined' &&
                $.isFunction(RVwys.widget[widget]['set_' + widgetname])
            ) {
                RVwys.widget[widget]['set_' + widgetname](oAttr);
            } else if (
                $.isFunction(parent.RVwys.widget[widget]['set_' + widgetname])
            ) {
                parent.RVwys.widget[widget]['set_' + widgetname](oAttr);
            }
            parent.$(panel).show();
        };

        RVwys.widget.attr = function (ths) {
            var obj = {};
            $.each(ths.get(0).attributes, function () {
                if (this.specified) {
                    obj[this.name] = this.value;
                }
            });
            return obj;
        };

        /**
         * @param {string} panel
         */
        function checkWidget(panel) {
            // Check to replace new panel name
            var old_widget = {
                '.wys-rowWidget_blog_blog_index': {
                    widgetname: 'blog_widget_blog_index',
                    widget: 'blog',
                    img: '.imgBlog',
                },
            };
            var widget_data;
            if (old_widget[panel]) {
                widget_data = old_widget[panel];
            }

            return widget_data;
        }

        RVwys.widget.elementReceive = function (oThis, e, ui) {
            RVwys.widget.Receive(ui, 'elementReceive');
        };

        RVwys.widget.sectionReceive = function (oThis, e, ui) {
            RVwys.widget.Receive(ui, 'sectionReceive');
        };

        RVwys.widget.Receive = function (ui, isWhere) {
            console.log(ui.get(0));
            console.log('test');
            var uiElem = ui.attr('data');
            var id = $.md5(String($.now()));
            var act = ui.attr('action')
                ? ui.attr('action')
                : '/admin/wysiwyg/widget/widgetsection';
            var widget = ui.attr('widget') || ui.attr('data-appname');

            var widgetname = ui.attr('widgetname');
            var panel = ui.attr('panel') ? ui.attr('panel') : '.' + widgetname;

            var bms = $('#blockMainSetting');

            var uiImg = ui.find('img.img' + widgetname);
            console.log('uiImg-->');
            console.log(uiImg.get(0));

            console.log(ui.get(0));
            console.log(widgetname);

            if (!uiImg.get(0) && ui.attr('data-id')) {
                //widgetname.replace('')
                var uiImg = ui.find('img.' + ui.attr('data-id'));
            }
            /*
            if ($.isFunction(parent.RVwys.widget[widget].setting)) {
                var settings = parent.RVwys.widget[widget].setting(ui);
            } else {
                var settings = RVwys.widget[widget].setting(ui);
            }

            console.log(settings);
            $.each(settings, function(settingkey, settingvalue) {
                uiImg.attr("setting_" + settingkey, settingvalue);
            });
            */
            var oImage = uiImg.clone().attr('id', id);

            RVwys.widget.overlay('show');
            $.ajax({
                type: 'POST',
                url: parent.wex.url.baseUrl + act,
                data: {
                    slug_name: parent.slugname,
                    widget: widget,
                    widgetname: widgetname,
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (response) {
                    RVwys.widget.overlay('hide');
                    if (isWhere == 'elementReceive') {
                        ui.html('').append($(response));
                    } else {
                        console.log(uiElem);

                        var sectionData = $(uiElem);
                        console.log(response);

                        sectionData.find('img').replaceWith($(response));
                        ui.html('').append(sectionData);
                    }

                    afterreceive(ui, panel, isWhere);
                },
                error: function (err) {
                    RVwys.widget.overlay('hide');
                    ui.remove();
                    console.log(err);
                    parent.console.pop.error({
                        text: err.message,
                        delay: 1000,
                    });
                },
            });

            function afterreceive(ui, panel) {
                if (isWhere == 'elementReceive') {
                    var othisNew = $(ui)
                        .find('.containerWidget')
                        .after(oImage.hide())
                        .end()
                        .html();
                    othisNew = $(othisNew);
                    var ele = $(ui)
                        .find('img#' + id)
                        .attr('element');
                    var wg = $(ui)
                        .find('img#' + id)
                        .attr('widget');

                    // elereplace
                    $(ele).replaceWith(othisNew);
                    $(wg).attr({
                        onclick: 'RVwys.widget.ovewEvent(this)',
                        panel: panel,
                        widget: widget,
                        widgetname: widgetname,
                    });
                } else {
                    var othisNew = $(
                        ui
                            .find('.mg')
                            .attr({
                                onclick: 'RVwys.widget.ovewEvent(this)',
                                panel: panel,
                                widget: widget,
                                widgetname: widgetname,
                            })
                            .find('.containerWidget')
                            .after(oImage.hide())
                            .end()
                            .end()
                            .find('.rvsb_design_block')
                            .prepend(bms.html())
                            .end()
                            .html()
                    );

                    ui.replaceWith(othisNew);
                }

                othisNew.find('a').click(function (e) {
                    var oThis = $(this);
                    if ($(this).is('a')) {
                        oThis = $(this).closest('#socialbutton');
                    }

                    RVwys.widget.ovewEvent(oThis);

                    if ($(this).attr('nowidget') != undefined) return false;
                    if ($(this).parent().parent().hasClass('pagination'))
                        return false;
                    $('.linkToolEditable').show();
                    $('.linkToolEditable')
                        .find('.linkToEdit')
                        .hide()
                        .end()
                        .find('.linkToRemove')
                        .hide();

                    var h = $(this).attr('href') || '';

                    h = h.replace(
                        parent.wex.url.baseUrl,
                        parent.wex.url.WYS_SHOW_URL
                    );
                    var oLinkk = $(
                        '<a href="' +
                            h +
                            '"> <i class="uk-icon-external-link"></i>  ' +
                            h +
                            '</a>'
                    );
                    if (!h.match(/^\#/)) {
                        oLinkk.attr('target', '_blank');
                    }
                    $('.linkTo').html(oLinkk);
                    $('.linkToolEditable').css({
                        left: $(this).offset().left,
                        top: $(this).offset().top,
                    });
                    return false;
                });

                //Only widget social
            }
        };

        if ($('.widgetSection').hasClass('ui-sortable')) {
            $('.widgetSection').sortable('destroy');
        }
        $('.widgetSection')
            .disableSelection()
            .sortable({
                connectWith: ['.editable_area', '.RVWYSIWYGAREA *'],
                cancel: '.consonant',
                appendTo: 'body',
                opacity: '.5',
                start: function (e, ui) {
                    //	$('.RVWYSIWYGAREA').disableSelection().sortable()
                },
                sort: function (e, ui) {
                    RVwys.hidemgActive();
                },
                placeholder: {
                    element: function (e, li) {
                        return $($('.tpl-placeholder').html())[0];
                    },
                    update: function (e, li) {
                        return;
                    },
                },
                helper: function (e, li) {
                    this.copyHelper = li.clone().insertAfter(li);
                    $(this).data('copied', false);
                    return $(
                        '<div class ="rvSWDhelper" style="width:200px;border:solid 3px #fcfcfc;"></div>'
                    );
                },

                stop: function (e, ui) {
                    var $uiItem = $(ui.item);
                    if ($uiItem.parent().is('.widgetSection')) $uiItem.remove();
                    $('.layoutResize').remove();

                    $('.RVWYSIWYGAREA')
                        .find('*')
                        .each(function () {
                            if ($(this).hasClass('ui-sortable')) {
                                //$(this).enableSelection().sortable('destroy');
                            }
                            if ($(this).get(0).className == '') {
                                $(this).removeAttr('class');
                            }
                        });
                },
            });

        //savewidget action
        parent.$('.savewidget').click(function () {
            var app = $(this).attr('app-name');
            var widget = $(this).attr('widget-name');
            $('.previewWidgetTools').hide();
            var datasetting = {};
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var id = parent.elmSetWidget.get(0).id;
            console.log('id');
            console.log(id);
            fb.$('#' + id).each(function () {
                $.each(this.attributes, function () {
                    if (this.specified) {
                        //console.log(this.name,this.value);
                        if (this.name.match(/setting_/g)) {
                            datasetting[this.name] = this.value;
                        }
                    }
                });
            });
            RVwys.widget.overlay('show');
            $.ajax({
                type: 'POST',
                url: '/admin/wysiwyg/widget/widgetpreview',
                data: {
                    widgetname: widget,
                    app: app,
                    setting: datasetting,
                    slug_name: parent.slugname,
                    slug_prefix: parent.slugprefix,
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (data) {
                    //var bl = $('<div/>').html(data);
                    //fb.$('#'+id).parent().find('.containerWidget').replaceWith($('<div/>').append(bl.find('.containerWidget')).html());
                    //alert(data)
                    //alert(fb.$('#'+id).get(0))
                    //alert(fb.$('#'+id).closest('.containerWidget').html())
                    var fb = parent.$('#frameBody').get(0).contentWindow;
                    var oRes = fb.$(data);
                    var eleWidget = window.isWidgetElement;

                    RVwys.widget.overlay('hide');
                    if (eleWidget) {
                        console.log('window.isWidgetElement');
                        console.log(eleWidget.get(0));
                        RVwys.widget.previewByImage(eleWidget, oRes);
                    } else {
                        var isWGGlobal = fb.$('#' + id).attr('setting_global');
                        var attrs = fb.$('#' + id).attrs();
                        delete attrs['style'];
                        delete attrs['class'];
                        delete attrs['id'];
                        delete attrs['src'];
                        delete attrs['srcs'];
                        console.log('widget attrs');
                        console.log(attrs);
                        if (isWGGlobal == '1') {
                            var widgetname = fb.$('#' + id).attr('widgetname');
                            obj = $(
                                "[widgetname='" +
                                    widgetname +
                                    "'][setting_global='1']"
                            );
                        } else {
                            obj = fb.$('#' + id);
                        }
                        obj.each(function () {
                            var conWidget = $(this)
                                .parent()
                                .find('.containerWidget');

                            if (conWidget.get(0)) {
                                //alert(isglobal)
                                $.when(
                                    $(this).attr(attrs),
                                    oRes.attr(attrs),
                                    $(this)
                                        .parent()
                                        .find('.containerWidget')
                                        .replaceWith(oRes.clone())
                                ).then(function (x) {
                                    $(this)
                                        .parent()
                                        .find('.containerWidget')
                                        .find('a')
                                        .click(function () {
                                            return fb.RVwys.widget.widgetNotAciveLink(
                                                this
                                            );
                                        });
                                });
                            }
                        });
                    }
                    //$('.overlaypanel').remove();
                },
                error: function (jqXHR, exception) {
                    //console.log(jqXHR.responseJSON);
                    //console.log(exception)
                    RVwys.widget.overlay('hide');
                    $('.overlaypanel').remove();
                    parent.console.pop.error({
                        text: jqXHR.responseJSON.message,
                    });
                },
            });
        });
    });

    // support old content widget
    RVwys.widget.blog.ovewEvent = function (oths) {
        if (!$(oths).attr('widget')) {
            oths = $(oths).attr('widget', 'blog');
        }

        RVwys.widget.ovewEvent(oths);
    };
    RVwys.widget.elementClick = function (oths, isWidgetEle = null) {
        console.log('elementClick');
        console.log(oths.get(0).outerHTML);
        var po = oths.offset();
        //if (!isWidgetEle) {
        parent.elmSetWidget = window.elmSetWidget = oths;
        parent.window.isWidgetElement = window.isWidgetElement = oths;
        var poLeft =
            po.left + (oths.width() / 2 - $('.previewWidgetTools').width() / 2);
        var poTop =
            po.top +
            (oths.height() / 2 - $('.previewWidgetTools').height() / 2);
        //alert(poLeft+'||'+poTop)
        $('.previewWidgetTools').css({ left: poLeft, top: poTop }).show();
        //}
        //RVwys.widget.showPanel(oths);
        RVwys.widget.apiWidgetFrame(oths);
    };
    RVwys.widget.previewByImage = function (oWidget, res) {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var id = oWidget.get(0).id;
        //alert('insertWidgetClone')
        //alert(oWidget.get(0).outerHTML)
        //alert(oWidget.attr('clone'))
        if (!oWidget.attr('clone')) {
            fb.$('.mgclone').remove();
            var block = oWidget.closest('.RVWYSIWYGAREA');
            var previewBlock = block
                .clone()
                .addClass('mgclone')
                .removeClass('RVWYSIWYGAREA')
                .removeAttr('id');
            //block.hide();
            block.after(previewBlock);
            block.addClass('mgMaster');
        } else {
            var previewBlock = oWidget.closest('.mgclone').get(0)
                ? oWidget.closest('.mgclone')
                : fb.$('div#' + id).closest('.mgclone');
        }
        var cpWidget = $(
            '<div class="uk-button uk-button-primary closePreviewWidget">Preview <span class="pull-right blockDelete"></span></div>'
        ).click(function () {
            RVwys.removePreviewWidget();
        });
        $.when(
            previewBlock
                .find('#' + id)
                .parent()
                .find('*:not(.containerWidget)')
                .unbind('click')
                .click(function () {
                    RVwys.removePreviewWidget();
                })
                .end()
                .find('#' + id)
                .replaceWith(
                    res.attr({
                        id: id,
                        contenteditable: 'false',
                    })
                ),
            previewBlock.parent().prepend(cpWidget)
        ).then(function () {
            previewBlock
                .find('a')
                .unbind('click')
                .click(function () {
                    return fb.RVwys.widget.widgetNotAciveLink(this);
                })
                .end()
                .find('.containerWidget#' + id)
                .attr('clone', 'true')
                .unbind('click')
                .click(function () {
                    $('.activeWidget').removeClass('activeWidget');
                    $(this).addClass('activeWidget');
                    var fb = parent.$('#frameBody').get(0).contentWindow;
                    var id = $(this).attr('id');
                    try {
                        var obj = parent.window.isWidgetElement
                            .closest('.RVWYSIWYGAREA')
                            .get(0)
                            ? parent.window.isWidgetElement.closest(
                                  '.RVWYSIWYGAREA'
                              )
                            : $(this).closest('.mgclone').prev();
                    } catch (e) {
                        obj = $(this).closest('.mgclone').prev();
                    }

                    parent.window.isWidgetElement = window.isWidgetElement = $(
                        this
                    );
                    //RVwys.widget.showPanel(obj.find('#'+id));
                    console.log(RVwys.widget);
                    console.log(RVwys.widget);
                    fb.RVwys.widget.apiWidgetFrame(obj.find('#' + id));
                })
                .end()
                .find('.insertwidget')
                .attr('clone', 'true')
                .unbind('click')
                .click(function () {
                    $('.activeWidget').removeClass('activeWidget');
                    $(this).addClass('activeWidget');

                    //RVwys.widget.elementClick($(this));
                    parent.window.isWidgetElement = window.isWidgetElement = $(
                        this
                    );
                    //RVwys.widget.showPanel($(this));
                    RVwys.widget.apiWidgetFrame($(this));
                })
                .end()
                .show();
            //window.isWidgetElement = res;
            //parent.window.isWidgetElement = res
            console.log('peview1');
            console.log(res.get(0));
        });
    };
    RVwys.widget.previewElement = function (oths) {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var oWidget = window.isWidgetElement;
        $('.previewWidgetTools').hide();
        //console.log('oWidget.get(0)')
        //console.log(oWidget.get(0))
        if (oWidget.get(0)) {
            var datasetting = {};

            fb.$(oWidget).each(function () {
                $.each(this.attributes, function () {
                    if (this.specified) {
                        //console.log(this.name,this.value);
                        if (this.name.match(/setting_/g)) {
                            datasetting[this.name] = this.value;
                        }
                    }
                });
            });

            realData = {};
            realData.app = oWidget.attr('widget');
            realData.widgetname = oWidget.attr('widgetname');
            realData.slug_name = parent.slug_name;
            realData.setting = datasetting;
            realData.slug_prefix = '';
            realData._token = $('meta[name="csrf-token"]').attr('content');
            RVwys.widget.overlay('show');
            $.ajax({
                url: '/admin/wysiwyg/widget/widgetpreview',
                type: 'POST',
                data: realData,
                success: function (response) {
                    RVwys.widget.overlay('hide');
                    var res = $(response);
                    RVwys.widget.previewByImage(oWidget, res);
                },
                error: function (err) {
                    RVwys.widget.overlay('hide');
                    parent.console.pop.error({
                        text: err.message,
                        delay: 1000,
                    });
                },
            });
        }
    };
    RVwys.designViewAddEvent('mouseup', function (e) {
        //detect youtube iframe onclick wys

        RVwys.removePreviewWidget();
        var curRangeTag = $(e.target);

        var tag = $(e.target).get(0).tagName.toLowerCase();
        parent.isWidgetElement = window.isWidgetElement = false;
        parent.elmSetWidget = window.elmSetWidget = false;
        $('.previewWidgetTools').hide();
        switch (tag) {
            case 'a':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'button':
            case 'h5':
            case 'h6':
            case 'b':
            case 'i':
            case 'u':
            case 'font':
                //console.pop.warning('Cannot insert widget into this <'+tag+'> element');
                break;
            case 'img':
                if ($(e.target).hasClass('insertwidget')) {
                    $('.activeWidget').removeClass('activeWidget');
                    $(this).addClass('activeWidget');
                    RVwys.widget.elementClick(curRangeTag);
                }
                break;
            default:
            // code block
        }
    });
})(jQuery);
